export type ConsentStatus = 'accepted' | 'rejected';

export interface ConsentRecord {
  status: ConsentStatus;
  analytics: boolean;
  version: number;
  updatedAt: string;
}

const CONSENT_STORAGE_KEY = 'fp_cookie_consent_v1';
const CONSENT_VERSION = 1;

export function getConsentRecord(): ConsentRecord | null {
  try {
    const raw = localStorage.getItem(CONSENT_STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as Partial<ConsentRecord>;

    if (!parsed || (parsed.status !== 'accepted' && parsed.status !== 'rejected')) {
      return null;
    }

    return {
      status: parsed.status,
      analytics: parsed.status === 'accepted',
      version: Number(parsed.version || CONSENT_VERSION),
      updatedAt: parsed.updatedAt || new Date().toISOString()
    };
  } catch (_) {
    return null;
  }
}

export function saveConsent(status: ConsentStatus): ConsentRecord {
  const record: ConsentRecord = {
    status,
    analytics: status === 'accepted',
    version: CONSENT_VERSION,
    updatedAt: new Date().toISOString()
  };

  localStorage.setItem(CONSENT_STORAGE_KEY, JSON.stringify(record));
  return record;
}

export function isAnalyticsAllowed(): boolean {
  const consent = getConsentRecord();
  return Boolean(consent?.analytics);
}
